/*
 * frankly-skin-test.js — Frank!y sampling funnel.
 * Vanilla JS, geen dependencies. Eén bestand bedient twee pagina's: de huidtest-modal
 * en de claimpagina. Ontbreekt de bijbehorende markup, dan no-opt het script netjes.
 * DOM-contract: CONTRACT.md §4 — wijk daar niet van af.
 *
 * TWEE SOORTEN MAIL, STRENG GESCHEIDEN
 *
 *   TRANSACTIONEEL — de bevestigingsmail met de claimlink. Iemand vraagt een sample
 *   aan, wij mailen waar dat heen mag. Dat is de afhandeling van zijn eigen verzoek,
 *   geen reclame, dus daar is géén marketingtoestemming voor nodig. Deze mail gaat
 *   dus ALTIJD weg, vinkje of niet — voor zover het gekozen kanaal het kan.
 *
 *   MARKETING — de nieuwsbrief (15% korting op de eerste aankoop vanaf € 20). Vereist
 *   toestemming, dus gaat alleen weg met het vinkje aan. Het vinkje begint leeg en
 *   wordt hier nooit programmatisch aangezet: een vooraf aangevinkt vakje is geen
 *   geldige toestemming (AVG overweging 32; HvJ Planet49, C-673/17).
 *
 * Wat welk kanaal kan:
 *
 *   esp 'klaviyo'  — transactioneel via het client EVENTS-endpoint (alleen company id
 *                    nodig; maakt/werkt het profiel bij zónder inschrijving).
 *                    Marketing via het client SUBSCRIPTIONS-endpoint (list id erbij).
 *   esp 'shopify'  — alléén marketing: {% form 'customer' %} ís een inschrijving.
 *                    Er bestaat hier geen transactionele route. De enige mail die deze
 *                    route oplevert is de opt-in-bevestiging van Shopify, en die
 *                    bestaat alleen als dubbele opt-in aan staat (Instellingen →
 *                    Klanten). Dat kan het theme niet uitlezen; de winkelier bevestigt
 *                    het met de configsleutel shopifyDoubleOptIn.
 *   esp 'none'     — niets.
 *
 * Daaruit volgt canEmail(): kan er voor deze bezoeker echt een mail uitgaan? Zo nee,
 * dan slaan we het inbox-scherm ("kijk in je mail") over en sturen we direct door naar
 * de claimpagina. Dat scherm mag nooit post beloven die niet komt.
 *
 * canEmail() kijkt daarom naar drie dingen, niet alleen naar de configuratie:
 * kán het kanaal mailen, mócht er gemaild worden (vinkje waar dat telt), en is de
 * POST die de mail veroorzaakt ook echt aangekomen (mailFailed). Dat laatste is geen
 * theorie: a.klaviyo.com staat op de gangbare tracker-blocklists, dus voor een deel
 * van de bezoekers wordt dat verzoek structureel geweigerd.
 *
 * Alle verzending is fire-and-forget: fouten landen in console.warn, de flow wacht
 * nergens op en de sample hangt van geen enkel verzoek af.
 *
 * MEETPUNTEN — waar haken bezoekers af?
 *
 * Twaalf meetpunten. Negen tekenen de trechter van "test geopend" tot "sample in de
 * winkelwagen"; drie tellen de kliks waarmee een bezoeker de funnel juist verlaat om
 * meteen te kopen. Ze lopen allemaal langs één functie, meet(), en die kent precies
 * één bestemming:
 *
 *   Shopify.analytics.publish(naam, gegevens) — het enige kanaal dat vanuit
 *   themacode een web pixel bereikt. Deze winkel heeft geen window.dataLayer en geen
 *   gtag(): GA4 draait in de sandbox van de pixel, dus een dataLayer.push vanuit dit
 *   bestand zou letterlijk nergens aankomen.
 *
 * Eén bestemming, en met opzet niet meer dan dat. Er gaat bewust GEEN DOM-event op
 * document mee: dat is een uitzending naar de hele pagina. Elke app, chatwidget,
 * reviewtool of onsite-script van een marketingpartij kan daarop meeluisteren, en de
 * eventnamen staan in dit publiek leesbare bestand, dus geheim zijn ze niet. Juist de
 * partijen die zo'n listener zouden hangen kennen het e-mailadres al — en dan is het
 * huidtype geen eigenschap van een gebeurtenis meer, maar van een persoon. publish()
 * gaat naar de pixels, en daar houdt het op.
 *
 * De twaalf namen:
 *
 *   frankly_test_geopend      { hervat }              de modal is opengegaan
 *   frankly_test_vraag        { vraag }               vraag 1..n in beeld
 *   frankly_test_email        —                       de e-mailstap in beeld
 *   frankly_test_email_fout   —                       adres afgekeurd door de validatie
 *   frankly_test_resultaat    { huidtype }            het resultaatscherm in beeld
 *   frankly_test_claim        { huidtype }            op "claim mijn gratis sample"
 *   frankly_claim_geopend     { huidtype, bron }      de claimpagina geladen
 *   frankly_claim_toegevoegd  { huidtype }            sample in de winkelwagen
 *   frankly_claim_fout        { reden }               claimen mislukt
 *   frankly_kaart_klik        { huidtype, kaart }     op een betaalde productkaart
 *   frankly_shoplink_klik     { huidtype }            op de tekstlink bij het resultaat
 *   frankly_inboxlink_klik    { huidtype }            op de tekstlink op het inbox-scherm
 *
 * DE LAATSTE DRIE ZIJN GEEN TRECHTERSTAPPEN. Ze tellen bezoekers die vanaf het
 * resultaat- of inbox-scherm doorklikken naar de winkel in plaats van hun sample te
 * claimen. Zonder controlegroep is niet te bewijzen of die afslag de sampleclaim
 * kost, maar de bovengrens van de schade is er wél mee te meten: klikt 2% van de
 * bezoekers weg, dan kan het effect op de claim per definitie hooguit 2 procentpunt
 * zijn. Daarvoor moeten die kliks apart geteld worden, en niet meelopen in een van de
 * negen trechterstappen. Zet ze in GA4 dus nooit ín de funnelverkenning van
 * FRANKLY-MEETPUNTEN.md §3C; lees ze los, naast stap 5.
 *
 * Ze zijn meteen geldige GA4-eventnamen — letters, cijfers en underscores, geen
 * dubbele punt — zodat een pixel ze zonder vertaaltabel kan doorzetten. Shopify's
 * documentatie schrijft als conventie "prefix:naam" met een dubbele punt voor; harde
 * validatie op eventnamen is nergens gedocumenteerd, en botsen met een standaardevent
 * kan niet (geen enkel standaardevent begint met frankly_). Dat de pixel-manager namen
 * zónder dubbele punt doorlaat is echter nergens toegezegd, en als het misgaat komt er
 * niets door zonder dat deze code dat kan merken. Controleer het dus één keer vóór
 * livegang met een tijdelijke pixel die niets anders doet dan
 * analytics.subscribe('all_custom_events', function (e) { console.log(e.name, e.customData); }),
 * en loop de funnel één keer door. Komt er niets binnen, zet dit bestand dan over op de
 * vorm frankly:test_geopend — de pixel in FRANKLY-MEETPUNTEN.md kent beide schrijfwijzen
 * al, dus dan hoeft alleen dit bestand mee.
 *
 * GEEN E-MAILADRES. Niet in de payload, niet in een parameter, nooit. Een adres is
 * een persoonsgegeven; daar is voor analytics geen grondslag onder de AVG en Google
 * verbiedt het uitdrukkelijk in zijn voorwaarden. Wat er wél in gaat is een
 * stapnummer, een huidtype en een korte, vaste reden — niets waarmee je iemand kunt
 * aanwijzen. Ook geen variant-ID, geen foutmelding van een server en geen tekst die
 * de bezoeker zelf heeft ingetypt: alleen waarden die dit bestand zelf kiest.
 * Het huidtype mag mee omdat het aan de GEBEURTENIS hangt en niet aan een persoon.
 * Los van een identiteit is "vette huid" een eigenschap van een gebeurtenis; hang je
 * het aan iemand, dan schuurt het tegen een gezondheidsgegeven aan (AVG art. 9). In
 * GA4 dus alleen als event-parameter — nooit als user property, nooit naast een
 * user_id.
 *
 * Toestemming: dit is een EU-winkel, dus zonder toestemming voor analytics gaat er
 * niets weg. Hoe dat gaat zonder de flow op te houden staat bij "meetpunten" verderop.
 *
 * En luistert er niets, dan gebeurt er ook niets: zonder pixel is publish() een
 * bericht zonder ontvanger. Om de trechter ergens te zien moet de winkelier één
 * custom pixel aanmaken (Instellingen → Klantevenementen) die zich op deze namen
 * abonneert en ze doorzet naar GA4. Custom events komen in géén enkel Shopify-rapport
 * terecht.
 */
(function () {
  'use strict';

  // ---------- config ----------

  var DEFAULTS = {
    storageKey: 'frankly.sample.v1',
    claimUrl: '/pages/sample-claim',
    esp: 'shopify',
    klaviyoCompanyId: '',
    klaviyoListId: '',
    // Naam van het transactionele Klaviyo-event. Hierop hangt de flow met de
    // claimlink; wijzig je hem hier of in het configblok, wijzig dan ook de trigger
    // van die flow, anders komt er stilzwijgend geen mail meer aan.
    klaviyoMetric: 'Sample aangevraagd',
    // Alleen van belang bij esp 'shopify'. Stuurt Shopify zelf een bevestigingsmail?
    // Dat hangt aan "dubbele opt-in" onder Instellingen → Klanten — een instelling
    // buiten het theme, die Liquid noch JS kan uitlezen. Staat hij uit, dan wordt de
    // klant stilzwijgend ingeschreven en gaat er HELEMAAL geen mail uit; het
    // inbox-scherm zou dan post beloven die nooit komt. Daarom bevestigt de winkelier
    // dit zelf in de sectie-instelling, en gaan we er zonder die bevestiging van uit
    // dat er geen mail is: bij twijfel beloven we er geen.
    shopifyDoubleOptIn: false,
    // Meetpunten aan of uit. De sleutel komt uit het configblok van de motor-sectie en
    // is daar de instelling "Meetpunten versturen" (section.settings.measurement_enabled).
    // Staat hij op false, dan publiceert dit bestand niets meer — de funnel zelf
    // verandert er niet van. Hij moet een echte JSON-boolean blijven, geen string:
    // meet() vergelijkt verderop met === false, en de tekst "false" is waar. De sectie
    // waarschuwt daar bij dat configblok zelf ook voor.
    // Ontbreekt het configblok of de sleutel — zoals op de claimpagina, die alleen een
    // storageKey meestuurt — dan geldt deze default en meet de funnel gewoon. De echte
    // schakelaar voor de winkelier is de pixel in de admin: is die er niet of staat
    // hij uit, dan komt er hoe dan ook niets aan.
    meten: true,
    tieOrder: ['oily', 'combi', 'blemish'],
    timeLines: {
      'Onder een minuut': 'Onder een minuut per dag. Dat lukt met deze twee.',
      'Een paar minuten': 'Twee producten, twee minuten per dag.',
      'Zoveel als nodig': 'Je neemt er de tijd voor. Deze twee vragen er weinig.'
    },
    timeLineDefault: 'Eén sample per persoon. Genoeg om te voelen of het klikt.',
    emailError: 'Daar komt geen mail aan. Check het adres.',
    customerTagPrefix: 'huidtype:',
    funnelTag: 'sample-funnel'
  };

  // Vaste NL-teksten die niet uit het configblok komen.
  var TXT_CLEAR = 'Je winkelwagen wordt geleegd zodat het sample gratis verzonden wordt. Nog een keer klikken om door te gaan.';
  var TXT_FAILED = 'Toevoegen lukte niet. Probeer het opnieuw of mail ons.';
  var TXT_CLEAR_FAILED = 'Je winkelwagen legen lukte niet. Probeer het opnieuw.';
  var TXT_CONFIRM = 'Ja, leeg mijn winkelwagen';
  var TXT_NO_VARIANT = 'Dit sample is nog niet gekoppeld in de admin. Neem contact met ons op, dan sturen we het alsnog op.';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var TITLE_ID = 'frankly-sheet-title';
  // Het aantal vragen staat NIET in deze code. Het volgt uit de panes die het
  // snippet rendert: q1, q2, q3, ... Een vraag toevoegen of weghalen is daarmee
  // een wijziging in de markup alleen. Stond dit hier hard, dan zou het aantal
  // stilzwijgend uit de pas gaan lopen met wat de bezoeker ziet — en dat merk je
  // pas aan een voortgangsbalk die op 83% blijft steken.
  var TAIL = ['email', 'result', 'inbox'];
  var MAX_AGE = 7 * 24 * 60 * 60 * 1000; // 7 dagen
  var KLAVIYO_REVISION = '2026-07-15';

  // Configblok lezen; ontbreekt of breekt het, dan gewoon de defaults.
  //
  // Het configblok bevat ook "newsLabel", de copy naast het nieuwsbrief-vinkje. Die
  // sleutel staat hier bewust NIET in DEFAULTS: het label wordt server-side gerenderd,
  // JS hoeft de tekst niet te kennen en mag hem al helemaal niet dupliceren. Eén plek
  // voor die copy, en dat is het configblok in de sectie.
  var cfg = (function () {
    var out = {}, k;
    for (k in DEFAULTS) if (DEFAULTS.hasOwnProperty(k)) out[k] = DEFAULTS[k];
    var node = document.querySelector('script[type="application/json"][data-frankly-config]');
    if (node) {
      try {
        var raw = JSON.parse(node.textContent);
        for (k in raw) if (raw.hasOwnProperty(k) && raw[k] !== null && raw[k] !== '') out[k] = raw[k];
      } catch (err) {
        console.warn('[frankly] configblok is geen geldige JSON, defaults gebruikt', err);
      }
    }
    if (!Array.isArray(out.tieOrder) || !out.tieOrder.length) out.tieOrder = DEFAULTS.tieOrder;
    if (!out.timeLines || typeof out.timeLines !== 'object') out.timeLines = DEFAULTS.timeLines;
    return out;
  })();

  // ---------- helpers ----------

  // Veilige closest() vanaf een willekeurig event-target.
  function closestFrom(node, selector) {
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function show(el) { if (el) el.removeAttribute('hidden'); }
  function hide(el) { if (el) el.setAttribute('hidden', ''); }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // localStorage is een beleefdheid, geen slot: alles in try/catch.
  function readStore() {
    try {
      var data = JSON.parse(window.localStorage.getItem(cfg.storageKey));
      if (!data || data.v !== 1 || !data.ts) return null;
      return Date.now() - data.ts > MAX_AGE ? null : data;
    } catch (err) { return null; }
  }
  function writeStore(payload) {
    try { window.localStorage.setItem(cfg.storageKey, JSON.stringify(payload)); } catch (err) {}
  }
  function clearStore() {
    try { window.localStorage.removeItem(cfg.storageKey); } catch (err) {}
  }

  // ---------- meetpunten ----------
  //
  // Zie de kop van dit bestand voor wélke meetpunten er zijn en waarom er geen
  // e-mailadres in gaat. Hier staat alleen het hoe.
  //
  // TOESTEMMING. Dit is een EU-winkel: geen toestemming voor analytics, geen event.
  //
  // window.Shopify.customerPrivacy staat er niet uit zichzelf; die komt pas na
  // Shopify.loadFeatures(), en dat duurt ~100-300 ms. Daar mag de trechter niet op
  // wachten. Dus: zolang de stand onbekend is gaan events in een klein buffertje in
  // het geheugen. Blijkt de toestemming er te zijn, dan gaan ze alsnog weg; blijkt ze
  // er niet te zijn, dan gaat het buffertje leeg de prullenbak in en is er nooit iets
  // verstuurd. Zo verliezen we de eerste stappen niet van iemand die pas bij vraag 3
  // op akkoord klikt, zónder ooit iets te versturen dat niet mag.
  //
  // Let op de drie namen voor hetzelfde ding in Shopify's API: de methode heet
  // analyticsProcessingAllowed(), het veld in het document-event analyticsAllowed en
  // de sleutel van currentVisitorConsent() analytics.
  var METEN_BUFFER_MAX = 25;
  var metenBuffer = [];
  var metenGeladen = false, metenLuistert = false, metenBufferVolGemeld = false;

  // 'ja' | 'nee' | 'onbekend'. Geweigerd én nog-niets-gekozen geven allebei false uit
  // analyticsProcessingAllowed(); alleen currentVisitorConsent() kent het verschil
  // ('' = de bezoeker heeft nog niets gekozen). Precies dat verschil bepaalt of een
  // event de prullenbak of het buffertje in gaat, dus het wordt hier apart uitgelezen.
  function metenStand() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.analyticsProcessingAllowed !== 'function') return 'onbekend';
    try {
      if (api.analyticsProcessingAllowed() === true) return 'ja';
      if (typeof api.currentVisitorConsent === 'function') {
        var keuze = api.currentVisitorConsent();
        var stand = keuze ? keuze.analytics : null;
        if (stand === '' || stand === null || typeof stand === 'undefined') return 'onbekend';
      }
    } catch (err) {
      // Onleesbare API is geen toestemming, maar ook geen weigering: laten staan.
      return 'onbekend';
    }
    return 'nee';
  }

  // De Consent API één keer per paginaweergave laten laden en één keer luisteren naar
  // een latere keuze. visitorConsentCollected vuurt alléén bij een wijziging, nooit
  // bij het aanhaken zelf — de stand uitlezen gebeurt daarom apart, in meet().
  // Ontbreekt loadFeatures, dan blijft de stand 'onbekend' en gaat er dus nooit iets
  // weg. Dat is de bedoelde uitkomst: bij twijfel niet versturen.
  //
  // De "al gedaan"-vlag gaat pas om als loadFeatures er ECHT was. Shopify's eigen
  // bundel laadt asynchroon, dus bij het eerste meetpunt kan window.Shopify.loadFeatures
  // nog ontbreken — op de claimpagina is dat het meest waarschijnlijk, want daar valt
  // frankly_claim_geopend al op DOMContentLoaded. Zetten we de vlag vóór die test, dan
  // wordt de Consent API daarna nooit meer opgevraagd, blijft de stand eeuwig
  // 'onbekend' en meet de hele funnel niets — ook niet bij bezoekers die netjes
  // toestemming gaven. Dus: alleen afvinken als de poging echt is gedaan, zodat een
  // volgend meetpunt het opnieuw probeert zodra Shopify's bundel er wel is.
  function metenConsentKlaarzetten() {
    if (!metenLuistert) {
      metenLuistert = true;
      try { document.addEventListener('visitorConsentCollected', metenSpoelen); }
      catch (err) { console.warn('[frankly] luisteren naar toestemming mislukt', err); }
    }
    if (metenGeladen) return;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        metenGeladen = true;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          metenSpoelen();
        });
      }
    } catch (err) {
      console.warn('[frankly] Consent API laden mislukt', err);
    }
  }

  // Buffer legen zodra de stand bekend is. Bij 'nee' wordt hij weggegooid zonder ooit
  // gebruikt te zijn; bij 'onbekend' blijft hij staan tot de bezoeker kiest.
  function metenSpoelen() {
    try {
      var stand = metenStand();
      if (stand === 'onbekend') return;
      var wachtrij = metenBuffer;
      metenBuffer = [];
      if (stand !== 'ja') return;
      for (var i = 0; i < wachtrij.length; i++) metenVerstuur(wachtrij[i].naam, wachtrij[i].gegevens);
    } catch (err) {
      console.warn('[frankly] meetpunten doorsturen mislukt', err);
    }
  }

  // De enige bestemming, met een eigen try/catch eromheen. De guard is nodig omdat
  // Shopify.analytics van de Web Pixels Manager komt en die niet gegarandeerd geladen
  // is op het moment dat dit script draait.
  //
  // Bewust synchroon en niet achter een setTimeout: dit is een bericht binnen de
  // pagina, het wacht nergens op en het kost niets zolang er geen pixel luistert.
  // publish() geeft het bericht wel over de framegrens door aan de sandbox van de
  // pixel, en dat is een postMessage — aankomst vóór een navigatie is dus niet
  // gegarandeerd. Waar dat telt (vlak voor het wegnavigeren) geeft de aanroepende
  // functie de gebeurtenislus daarom eerst één beurt; zie goToClaim() en handleClaim().
  function metenVerstuur(naam, gegevens) {
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(naam, gegevens);
      }
    } catch (err) {
      console.warn('[frankly] meetpunt ' + naam + ' publiceren mislukt', err);
    }
  }

  // De enige ingang. Alles zit in try/catch: een meetpunt dat de test ophoudt is
  // erger dan geen meetpunt.
  function meet(naam, gegevens) {
    try {
      if (cfg.meten === false) return;
      var data = gegevens || {};
      metenConsentKlaarzetten();
      var stand = metenStand();
      if (stand === 'nee') return;
      if (stand === 'onbekend') {
        // Nog niets besloten, of de API is nog niet geladen. Bewaren, niet versturen:
        // dit buffertje staat in het geheugen, gaat het apparaat niet op en verlaat de
        // pagina niet. Vol is vol — twaalf meetpunten passen ruim, en een
        // ongelimiteerde lijst is een geheugenlek dat op niets uitloopt.
        if (metenBuffer.length < METEN_BUFFER_MAX) {
          metenBuffer.push({ naam: naam, gegevens: data });
        } else if (!metenBufferVolGemeld) {
          // Loopt de buffer vol, dan is de toestemmingsstand al die tijd onbekend
          // gebleven. Dat is één keer melden waard: anders is een stille storing —
          // Consent API die nooit laadt, banner die niets naar Shopify doorgeeft —
          // van buiten niet van "de bezoeker heeft nog niet gekozen" te onderscheiden.
          metenBufferVolGemeld = true;
          console.warn('[frankly] toestemmingsstand blijft onbekend, meetpunten worden niet bewaard vanaf ' + naam);
        }
        return;
      }
      metenVerstuur(naam, data);
    } catch (err) {
      console.warn('[frankly] meetpunt ' + naam + ' mislukt', err);
    }
  }

  // Elk meetpunt zegt "deze bezoeker heeft deze stap bereikt", niet "hoe vaak". Twee
  // keer dezelfde stap tellen maakt van een gezonde trechter een lek: telt vraag 3
  // dubbel en vraag 2 niet, dan leest de winkelier een uitval die er niet is. Daarom
  // vuurt elk meetpunt hooguit één keer per paginaweergave, op naam of op een eigen
  // sleutel (vraagnummer, foutreden). De sleutels krijgen een prefix zodat een naam
  // als "constructor" niet per ongeluk iets van Object.prototype raakt.
  var gemeten = {};
  function meetEens(naam, gegevens, sleutel) {
    var k = 'meet:' + (sleutel || naam);
    if (gemeten[k] === true) return;
    gemeten[k] = true;
    meet(naam, gegevens);
  }

  // Routes nooit hardcoden: de winkel heeft een taalkiezer aan.
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function cartBase() { return (window.routes && window.routes.cart_url) || shopRoot() + 'cart'; }
  function cartAddUrl() { return (window.routes && window.routes.cart_add_url) || shopRoot() + 'cart/add.js'; }

  // ---------- focus & scroll ----------

  var FOCUSABLE = 'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [draggable], area, ' +
    'input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe';
  var ownKeydown = null;

  // De modal rendert alle panes tegelijk en verbergt de inactieve met [hidden]
  // (.frankly-scope [hidden] { display: none !important }). Een focuslijst zonder
  // zichtbaarheidsfilter bevat dus de knoppen van álle vragen plus de claimknop:
  // .focus() daarop doet niets en Tab loopt de dialoog uit. Daarom filteren.
  function isReachable(el) {
    if (el.closest('[hidden]')) return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function focusables(container) {
    return toArray(container.querySelectorAll(FOCUSABLE)).filter(isReachable);
  }

  // Eigen trap: herberekent de lijst bij élke Tab, dus altijd over de actieve pane.
  function ownTrap(container, elementToFocus) {
    ownUntrap();
    ownKeydown = function (event) {
      if (event.key !== 'Tab' && event.keyCode !== 9) return;
      var list = focusables(container);
      var active = document.activeElement;
      if (!list.length) {
        // Niets focusbaars zichtbaar: focus terug naar de dialoog zelf (tabindex=-1).
        event.preventDefault();
        if (active !== container && typeof container.focus === 'function') container.focus();
        return;
      }
      var first = list[0], last = list[list.length - 1];
      if (!container.contains(active)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && (active === first || active === container)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', ownKeydown);
    if (elementToFocus) elementToFocus.focus();
  }
  function ownUntrap(elementToFocus) {
    if (ownKeydown) document.removeEventListener('keydown', ownKeydown);
    ownKeydown = null;
    if (elementToFocus) elementToFocus.focus();
  }

  // Bewust NIET window.trapFocus/getFocusableElements van Dawn (assets/global.js):
  // die nemen één momentopname van de eerste en laatste focusbare knop over de hele
  // card, inclusief de verborgen panes. `last` is dan de claimknop uit de
  // resultaatpane, die op vraag 1 display:none is — Tab ontsnapt naar de pagina
  // achter het scrim en Shift+Tab blijft hangen. De handoff noemt de focus trap
  // niet-onderhandelbaar, dus we gebruiken altijd de eigen trap.
  function trap(container, elementToFocus) {
    // Staat er nog een Dawn-trap aan (open drawer), die eerst uitzetten: anders
    // vechten twee keydown-handlers om dezelfde Tab.
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus();
    ownTrap(container, elementToFocus);
  }
  function untrap(elementToFocus) {
    ownUntrap(elementToFocus);
  }

  // Scroll-lock: Dawn's .overflow-hidden als die echt iets doet, anders inline.
  var inlineLock = null;
  function lockScroll() {
    document.body.classList.add('overflow-hidden');
    if (window.getComputedStyle(document.body).overflowY !== 'hidden') {
      inlineLock = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  }
  function unlockScroll() {
    document.body.classList.remove('overflow-hidden');
    if (inlineLock !== null) { document.body.style.overflow = inlineLock; inlineLock = null; }
  }

  // ---------- huidtest-modal ----------

  function initTest(sheet) {
    var card = sheet.querySelector('[data-frankly-card]');
    var body = sheet.querySelector('[data-frankly-body]');
    if (!card || !body) return;

    var stepLabel = sheet.querySelector('[data-frankly-step-label]');
    var progress = sheet.querySelector('[data-frankly-progress]');
    var progressFill = sheet.querySelector('[data-frankly-progress-fill]');
    // De voortgangsbolletjes. Ze staan er niet noodzakelijk: rendert de markup ze
    // niet, dan blijft dotItems leeg en doet updateDots() niets. De lijst is
    // server-side gerenderd en verandert daarna niet meer, dus één keer uitlezen.
    var dotList = sheet.querySelector('[data-frankly-dots]');
    var dotItems = dotList ? toArray(dotList.querySelectorAll('.frankly-dot')) : [];
    var timeLineEl = sheet.querySelector('[data-frankly-time-line]');
    var inboxEmail = sheet.querySelector('[data-frankly-inbox-email]');
    var emailInput = sheet.querySelector('[data-frankly-email]');
    var emailError = sheet.querySelector('[data-frankly-email-error]');
    var newsInput = sheet.querySelector('[data-frankly-news]');
    var emailSubmit = sheet.querySelector('[data-frankly-email-submit]');

    var panes = {};
    toArray(sheet.querySelectorAll('[data-frankly-pane]')).forEach(function (pane) {
      panes[pane.getAttribute('data-frankly-pane')] = pane;
    });

    // De vragen komen uit de markup, op nummer gesorteerd. QUESTIONS.length is
    // dus het echte aantal vragen dat de bezoeker krijgt — daar hangen het
    // stap-label en de voortgangsbalk aan.
    var QUESTIONS = Object.keys(panes)
      .filter(function (naam) { return /^q\d+$/.test(naam); })
      .sort(function (a, b) { return Number(a.slice(1)) - Number(b.slice(1)); });
    var STEPS = QUESTIONS.concat(TAIL);

    var results = toArray(sheet.querySelectorAll('[data-frankly-result]'));

    // state.news = gaf deze bezoeker marketingtoestemming? Bepaalt of de nieuwsbrief-
    // inschrijving weggaat en, in de Shopify-route, of er überhaupt een mail komt.
    var state = { step: 'q1', scores: { oily: 0, combi: 0, blemish: 0 }, tijd: '', email: '', type: '', handle: '', news: false };
    var openedBy = null, animBusy = false, tOut = null, tIn = null, tClose = null, tChoice = null;
    var inputLockUntil = 0, submitted = false;

    // Is de POST die de bevestigingsmail veroorzaakt níet aangekomen? Dan is er geen
    // mail onderweg, hoe goed de configuratie er ook uitziet, en mag het inbox-scherm
    // niet verschijnen. Dat scherm heeft bewust geen knop, dus het zou een doodlopend
    // eind zijn: geen mail, geen claimlink, geen weg terug. canEmail() leest deze
    // vlag; markMailFailed() zet hem. Hij gaat mee in localStorage, zodat een refresh
    // de bezoeker niet alsnog op dat scherm zet.
    var mailFailed = false;
    // Eén keer waarschuwen per paginaweergave; canEmail() wordt vaker aangeroepen.
    var warnedOptIn = false;

    // Kwam de stap waarop de modal opengaat uit localStorage, of begint deze bezoeker
    // vers? Alleen bij een verse start hoort de eerste pane geteld te worden — zie
    // openSheet() voor waarom hervatten niet meetelt.
    var hervat = false;

    // Antwoordknoppen blijven tijdens de panewissel in de DOM staan (en bij
    // prefers-reduced-motion wisselt de pane meteen), dus een dubbeltik zou
    // dezelfde vraag twee keer scoren of per ongeluk de volgende beantwoorden.
    var INPUT_COOLDOWN = 300;

    // De keuze-bevestiging: het aangetikte antwoord licht op, en pas daarna begint de
    // panewissel. Deze 150 ms zit BINNEN de invoervergrendeling hierboven, niet
    // erbovenop — lockInput() gaat om op het moment van tikken, dus na de wachttijd
    // resteert nog 150 ms cooldown en daarna neemt animBusy het over. Er valt geen gat
    // in de vergrendeling.
    //
    // Gratis is de wachttijd niet, en dat is een bewuste ruil. De vergrendeling houdt
    // alleen invoer tegen; ze vertraagt de panewissel niet. goTo() begint nu pas op
    // t=150 ms en doet er zelf nog 150 ms over, dus de bezoeker wacht 300 ms per vraag
    // in plaats van 150 ms — over vijf vragen zo'n 750 ms extra. Verhoog deze waarde
    // dus niet in de veronderstelling dat ze niets kost.
    //
    // Deze wachttijd geldt OOK bij prefers-reduced-motion, en dat is een bewuste
    // afwijking van de opdrachtregel "bij prefers-reduced-motion geen wachttijd".
    // Reden: die regel noemt er zelf een doel bij ("zodat de bevestiging zichtbaar
    // is") en dat doel haalt hij niet. Zonder wachttijd draait applyStep() in dezelfde
    // slag als de klik, wordt de pane met de aangetikte knop meteen op [hidden] gezet,
    // en is er geen enkel frame waarin de bevestiging op het scherm staat — de klasse
    // wordt dan gezet en nooit getekend. Wachten is hier ook niet wat de
    // reduced-motion-voorkeur uitsluit: die gaat over beweging, en er beweegt niets.
    // De bevestiging staat 150 ms stil in beeld; de animatie eromheen zet
    // frankly-funnel.css §18 uit. Zie ijzeren regel 3 van de handoff: de
    // keuze-bevestiging moet ook zonder beweging zichtbaar blijven.
    var CHOICE_DELAY = 150;

    // --- weergave ---

    function labelFor(step) {
      var i = QUESTIONS.indexOf(step);
      if (i > -1) return 'Vraag ' + (i + 1) + ' van ' + QUESTIONS.length;
      if (step === 'email') return 'Bijna klaar';
      if (step === 'result') return 'Je resultaat';
      if (step === 'inbox') return 'Check je inbox';
      return '';
    }

    // Voortgang loopt over de vragen; e-mail, resultaat en inbox staan vol.
    // Positie in QUESTIONS, niet het cijfer in de panenaam: dan blijft de balk
    // kloppen als er ooit een vraag tussenuit gaat en de nummering een gat krijgt.
    function percentFor(step) {
      var i = QUESTIONS.indexOf(step);
      if (i === -1) return 100;
      return Math.round(((i + 1) / QUESTIONS.length) * 100);
    }

    // De bolletjes: .is-done voor de vragen die achter de rug zijn, .is-current voor
    // de vraag die in beeld staat. Buiten de vragen — e-mail, resultaat, inbox — is
    // alles beantwoord en staat er niets meer op "nu", net zoals de balk daar vol
    // staat.
    //
    // Het aantal komt uit QUESTIONS, dezelfde lijst als het stap-label en de balk; in
    // deze functie staat dus geen enkel getal. Rendert de markup meer of minder
    // bolletjes dan er vraagpanes zijn, dan lopen die twee uit de pas — dat is een
    // fout in de markup en geen reden om de test te laten struikelen, dus we melden
    // het één keer en werken bij wat er staat.
    //
    // De bolletjes zijn aria-hidden en dus puur decoratief; het stap-label zegt
    // dezelfde voortgang al in woorden en dat is wat een schermlezer voorleest.
    // Daarom staat hier geen aria-attribuut en hoeft deze functie niets aan te
    // kondigen.
    var dotMismatchGemeld = false;
    function updateDots(step) {
      if (!dotItems.length) return;
      if (dotItems.length !== QUESTIONS.length && !dotMismatchGemeld) {
        dotMismatchGemeld = true;
        console.warn('[frankly] ' + dotItems.length + ' voortgangsbolletjes bij ' +
          QUESTIONS.length + ' vragen; de markup en de panes lopen uit de pas');
      }
      var i = QUESTIONS.indexOf(step);
      for (var d = 0; d < dotItems.length; d++) {
        dotItems[d].classList.toggle('is-done', i === -1 || d < i);
        dotItems[d].classList.toggle('is-current', i > -1 && d === i);
      }
    }

    // De titel van de zichtbare pane; bij 'result' zit die in het onthulde blok.
    // De test kijkt alleen naar [hidden] BINNEN de pane: bij het hervatten draait
    // applyStep() nog terwijl de sheet zelf hidden is, en dan zou een kale
    // closest('[hidden]') voor élke titel waar zijn en altijd op de eerste (oily)
    // kop terugvallen — de screenreader kondigt dan het verkeerde huidtype aan.
    function visibleTitle(pane) {
      var list = toArray(pane.querySelectorAll('[data-frankly-pane-title]'));
      for (var i = 0; i < list.length; i++) {
        var h = list[i].closest('[hidden]');
        if (!h || h === pane || !pane.contains(h)) return list[i];
      }
      return list[0] || null;
    }

    // aria-labelledby wijst naar één vast id; dat id verhuist mee met de pane.
    function moveTitleId(pane) {
      var target = visibleTitle(pane);
      if (!target) return null;
      var current = document.getElementById(TITLE_ID);
      if (current !== target) {
        if (current) current.removeAttribute('id');
        target.id = TITLE_ID;
      }
      return target;
    }

    // Focus naar de card zelf (role="dialog" tabindex="-1"), zoals Dawn's ModalDialog:
    // de screenreader leest "dialoog" + de titel waar aria-labelledby naar wijst.
    function focusCard() {
      trap(card, card);
    }

    // --- scoren ---

    // Hoogste score wint; gelijkspel lost op in de volgorde van cfg.tieOrder.
    function computeType() {
      var best = cfg.tieOrder[0], bestValue = -1;
      for (var i = 0; i < cfg.tieOrder.length; i++) {
        var value = state.scores[cfg.tieOrder[i]] || 0;
        if (value > bestValue) { bestValue = value; best = cfg.tieOrder[i]; }
      }
      return best;
    }

    function handleFor(key) {
      for (var i = 0; i < results.length; i++) {
        if (results[i].getAttribute('data-frankly-result') === key) {
          return results[i].getAttribute('data-frankly-handle') || '';
        }
      }
      return '';
    }

    // --- de twee tekstlinks naar de huidtype-pagina ---
    //
    // De markup rendert ze leeg, hidden en zonder href; de volledige afspraak staat
    // bij de link zelf in snippets/frankly-skin-test-modal.liquid. Kort: de bestemming
    // is `shop_url` uit het metaobject, die verschilt per huidtype, en het huidtype is
    // pas na de laatste vraag bekend. Het resultaatblok dat toch al onthuld wordt
    // draagt de waarde als data-attribuut, dus daar leest dit script hem uit.
    //
    // Blijft `shop_url` leeg — de normale toestand tot de winkelier het veld vult, en
    // ook wat er gebeurt zolang de pane-snippet het attribuut nog niet meegeeft — dan
    // blijven beide links hidden én zonder href. Dat laatste is geen detail: een <a>
    // zonder href is geen link, krijgt geen focus en valt dus buiten de focus-trap. Zo
    // staat er nooit een dode link in de tabvolgorde.
    var shopLinkEls = [
      sheet.querySelector('[data-frankly-shop-link]'),
      sheet.querySelector('[data-frankly-inbox-link]')
    ];
    var shopTypeEl = sheet.querySelector('[data-frankly-shop-type]');
    var shopUrlGemeld = false;

    // Alleen een pad op deze winkel of een http(s)-adres. frankly-skin-types.liquid
    // keurt de waarde server-side al op dezelfde regel; dit is de tweede grendel, want
    // wat hier doorheen komt gaat rechtstreeks in een href en escapen houdt een
    // `javascript:`-adres niet tegen. Een tweede slash of backslash valt er ook uit:
    // //ergensanders.nl is protocolrelatief en wijst de winkel uit, ook al begint het
    // met een schuine streep.
    function bruikbareShopUrl(url) {
      var v = (url || '').trim();
      if (!v) return '';
      if (v.charAt(0) === '/') return (v.charAt(1) === '/' || v.charAt(1) === '\\') ? '' : v;
      return /^https?:\/\//i.test(v) ? v : '';
    }

    function updateShopLinks() {
      var blok = resultElFor(state.type || computeType());
      var ruw = (blok && blok.getAttribute('data-frankly-shop-url')) || '';
      var url = bruikbareShopUrl(ruw);
      if (ruw && !url && !shopUrlGemeld) {
        shopUrlGemeld = true;
        console.warn('[frankly] shop_url is geen pad of http(s)-adres, tekstlink blijft weg');
      }
      // De chip draagt het label van het huidtype ('Vette huid'); CSS maakt er
      // hoofdletters van, de tekst zelf blijft zoals de winkelier hem typte. Midden in
      // een zin hoort hij klein. Ontbreekt de chip, dan is 'huid' de terugval, zodat
      // de regel een zin blijft in plaats van dood te lopen op een lege plek.
      var chip = blok ? blok.querySelector('.frankly-chip') : null;
      var naam = ((chip && chip.textContent) || '').trim().toLowerCase() || 'huid';
      if (shopTypeEl) shopTypeEl.textContent = naam; // nooit innerHTML
      for (var i = 0; i < shopLinkEls.length; i++) {
        var link = shopLinkEls[i];
        if (!link) continue;
        if (url) { link.setAttribute('href', url); show(link); }
        else { link.removeAttribute('href'); hide(link); }
      }
    }

    // Het resultaatblok van één huidtype. handleFor() loopt dezelfde lijst af voor de
    // handle; dit levert het element zelf, want updateShopLinks() heeft er twee dingen
    // uit nodig.
    function resultElFor(key) {
      for (var i = 0; i < results.length; i++) {
        if (results[i].getAttribute('data-frankly-result') === key) return results[i];
      }
      return null;
    }

    // Onthult één server-side gerenderd resultaat, verbergt de andere twee.
    function renderResult() {
      var key = computeType(), chosen = null;
      results.forEach(function (el) {
        if (el.getAttribute('data-frankly-result') === key) { show(el); chosen = el; }
        else hide(el);
      });
      if (!chosen && results.length) {
        chosen = results[0];
        show(chosen);
        key = chosen.getAttribute('data-frankly-result') || key;
      }
      state.type = key;
      state.handle = (chosen && chosen.getAttribute('data-frankly-handle')) || key;
      if (timeLineEl) timeLineEl.textContent = (cfg.timeLines[state.tijd] || cfg.timeLineDefault);
    }

    // --- stapwissel ---

    function persist() {
      // q is puur informatief in de opslag; hervatten gebeurt op `step`.
      var i = QUESTIONS.indexOf(state.step);
      writeStore({
        v: 1, step: state.step, q: i > -1 ? i + 1 : QUESTIONS.length, scores: state.scores,
        tijd: state.tijd, email: state.email, type: state.type, handle: state.handle,
        news: state.news, mailFailed: mailFailed, claimed: false, ts: Date.now()
      });
    }

    // De drie meetpunten die aan een stapwissel hangen, op één plek. Elke route naar
    // een volgende pane loopt via applyStep(): met animatie, zonder animatie en met
    // prefers-reduced-motion. Eén aanroep hier dekt ze alle drie.
    function meetStap(step) {
      var i = QUESTIONS.indexOf(step);
      if (i > -1) { meetEens('frankly_test_vraag', { vraag: i + 1 }, 'vraag:' + (i + 1)); return; }
      if (step === 'email') { meetEens('frankly_test_email'); return; }
      // renderResult() heeft state.type hierboven al gezet; computeType() is het
      // vangnet voor het geval de resultaatpane geen enkel blok kon onthullen.
      if (step === 'result') meetEens('frankly_test_resultaat', { huidtype: state.type || computeType() });
    }

    // stil = deze stapwissel niet meten. Alleen waar voor het hervatten uit
    // localStorage; elke gewone stapwissel telt wel.
    function applyStep(step, moveFocus, stil) {
      state.step = step;
      Object.keys(panes).forEach(function (name) {
        var pane = panes[name];
        if (name === step) { show(pane); pane.classList.add('is-active'); }
        else { hide(pane); pane.classList.remove('is-active'); }
      });
      if (step === 'result') renderResult();
      if (step === 'inbox' && inboxEmail) inboxEmail.textContent = state.email; // nooit innerHTML
      // Dezelfde tekstlink staat op twee schermen. Ook bij 'inbox' bijwerken, niet
      // alleen in renderResult(): wie zijn test hervat en meteen op het inbox-scherm
      // terugkomt, komt daar zonder langs 'result' te gaan — dan zou de link daar
      // zonder href blijven staan.
      if (step === 'result' || step === 'inbox') updateShopLinks();

      if (stepLabel) stepLabel.textContent = labelFor(step);
      var pct = percentFor(step);
      if (progressFill) progressFill.style.width = pct + '%';
      if (progress) progress.setAttribute('aria-valuenow', String(pct));
      // Bolletjes bij élke stapwissel, dus ook bij het hervatten (dat loopt hier
      // langs met stil = true) en bij de stap terug van inbox naar resultaat.
      updateDots(step);

      var pane = panes[step];
      if (pane) {
        moveTitleId(pane);
        if (moveFocus !== false) focusCard();
      }
      persist();
      if (!stil) meetStap(step);
    }

    function setAnim(value) {
      body.classList.remove('is-out', 'is-in');
      if (value) { body.classList.add('is-' + value); body.setAttribute('data-frankly-anim', value); }
      else body.removeAttribute('data-frankly-anim');
    }

    // Transitiehelper uit de handoff: 'out' → 150 ms → patch + 'in' → 30 ms → leeg.
    function goTo(step, moveFocus) {
      if (!panes[step] || step === state.step || animBusy) return;
      if (reduceMotion()) { applyStep(step, moveFocus); return; }
      animBusy = true;
      setAnim('out');
      clearTimeout(tOut); clearTimeout(tIn);
      tOut = setTimeout(function () {
        applyStep(step, moveFocus);
        setAnim('in');
        tIn = setTimeout(function () { setAnim(''); animBusy = false; }, 30);
      }, 150);
    }

    function next() {
      var i = STEPS.indexOf(state.step);
      if (i > -1 && i < STEPS.length - 1) goTo(STEPS[i + 1]);
    }

    // Antwoorden negeren zolang de wissel loopt én kort daarna. De guard zit
    // bewust vóór het scoren: goTo() stapt wel uit op animBusy, maar dan is de
    // score al opgehoogd en komt er een ander huidtype uit.
    function inputLocked() { return animBusy || Date.now() < inputLockUntil; }
    function lockInput() { inputLockUntil = Date.now() + INPUT_COOLDOWN; }

    // --- keuze-bevestiging ---

    // Eén gekozen antwoord per vraag. De klasse van een eerder antwoord in dezelfde
    // pane gaat er eerst af; zonder scope zou een tweede oplichtend antwoord in beeld
    // kunnen komen bij een vraag die opnieuw wordt getoond.
    function clearChosen(scope) {
      toArray((scope || sheet).querySelectorAll('.frankly-option.is-chosen'))
        .forEach(function (el) { el.classList.remove('is-chosen'); });
    }

    function markChosen(option) {
      if (!option || !option.classList) return;
      clearChosen(closestFrom(option, '[data-frankly-pane]'));
      option.classList.add('is-chosen');
    }

    // Eerst de bevestiging, dan pas de panewissel. De aanroeper heeft op dat moment al
    // gescoord en lockInput() gedaan, dus een tweede tik in deze 150 ms wordt door
    // inputLocked() geweigerd en de wachttijd valt volledig binnen de vergrendeling.
    //
    // De timer wordt bij het sluiten van de modal opgeruimd (closeSheet). Het vangnet
    // hieronder vangt de resterende gevallen af: staat de sheet weer op hidden, dan is
    // de bezoeker weg en mag deze stapwissel niet alsnog gebeuren — hij zou de
    // bewaarde stap opschuiven naar een vraag die nooit in beeld is geweest.
    function chooseAndAdvance(option) {
      markChosen(option);
      clearTimeout(tChoice);
      tChoice = setTimeout(function () {
        if (sheet.hasAttribute('hidden')) return;
        next();
      }, CHOICE_DELAY);
    }

    // --- openen en sluiten ---

    // Het vinkje begint leeg en wordt hier ook leeggemaakt. Dat is niet alleen de
    // begintoestand uit de markup: browsers herstellen bij een refresh vaak zelf de
    // stand van formuliervelden, en dan zou de bezoeker een aangevinkt vakje te zien
    // krijgen dat hij op dít scherm niet heeft aangevinkt. Vooraf aangevinkt is geen
    // geldige toestemming (AVG overweging 32; HvJ Planet49, C-673/17), dus dat vakje
    // is altijd leeg als de e-mailstap opnieuw in beeld komt.
    function clearNewsBox() {
      if (newsInput) newsInput.checked = false;
    }

    function reset() {
      state.scores = { oily: 0, combi: 0, blemish: 0 };
      state.tijd = state.email = state.type = state.handle = '';
      state.news = false;
      mailFailed = false;
      if (emailInput) emailInput.value = '';
      clearNewsBox();
      submitted = false;
      if (emailSubmit) emailSubmit.disabled = false;
      hideEmailError();
      // Een verse test begint zonder oplichtende antwoorden. De knoppen blijven een
      // hele paginaweergave in de DOM staan, dus zonder dit zou iemand die zijn test
      // opnieuw begint zijn oude keuzes nog aangevinkt zien staan.
      clearChosen();
    }

    // Hervat een bewaarde staat: jonger dan 7 dagen en nog niet geclaimd.
    function resume() {
      var saved = readStore();
      hervat = false;
      if (!saved || saved.claimed || STEPS.indexOf(saved.step) === -1) { reset(); return 'q1'; }
      hervat = true;
      var s = saved.scores || {};
      state.scores = { oily: Number(s.oily) || 0, combi: Number(s.combi) || 0, blemish: Number(s.blemish) || 0 };
      state.tijd = typeof saved.tijd === 'string' ? saved.tijd : '';
      state.email = typeof saved.email === 'string' ? saved.email : '';
      // Wél terughalen wat er destijds is verstuurd (daar hangt canEmail() aan),
      // maar het vakje zelf blijft leeg: dit is een vastlegging van een eerdere
      // handeling, geen alvast ingevulde toestemming voor een volgende.
      state.news = !!saved.news;
      state.type = typeof saved.type === 'string' ? saved.type : '';
      state.handle = typeof saved.handle === 'string' ? saved.handle : '';
      // Een mislukte verzending blijft mislukt: hij wordt niet opnieuw geprobeerd, dus
      // een refresh mag de bezoeker niet alsnog op het inbox-scherm zetten.
      mailFailed = !!saved.mailFailed;
      if (emailInput && state.email) emailInput.value = state.email;
      clearNewsBox();
      hideEmailError();
      // Het inbox-scherm belooft een mail. Kan die er voor deze bezoeker niet zijn —
      // omdat de winkel intussen op een ander ESP is gezet, of omdat de POST die de
      // mail veroorzaakt niet is aangekomen — dan is die belofte niet waar en zetten
      // we hem terug op zijn resultaat, waar de claimknop hem verder helpt.
      if (saved.step === 'inbox' && !canEmail()) return 'result';
      return saved.step;
    }

    function openSheet(opener) {
      clearTimeout(tClose);
      // Een keuze die nog in de wacht stond hoort niet bij deze opening: resume()
      // hieronder bepaalt de startstap, en een oude timer zou daar overheen stappen.
      clearTimeout(tChoice);
      openedBy = opener || document.activeElement;
      // resume() eerst: die bepaalt de startstap én zet `hervat`.
      var start = resume();
      // De stand van `hervat` gaat mee. Dat is geen extraatje maar een correctie: de
      // stapwissel hieronder houdt zich stil bij hervatten, dus zonder dit veld levert
      // een terugkerende bezoeker wél "test geopend" op en géén enkele vraag — een
      // uitval boven aan de trechter die er niet is. Met het veld erbij blijft de
      // bezoeker zichtbaar (hij ópende de test tenslotte) en kan de trechter op
      // hervat = 'nee' gefilterd worden, zodat stap 1 en stap 2 over dezelfde
      // populatie gaan. 'ja'/'nee' als tekst, want GA4 maakt van een getal of een
      // boolean een statistiek waar je niet op kunt filteren.
      meetEens('frankly_test_geopend', { hervat: hervat ? 'ja' : 'nee' });
      // Hervat de bezoeker een eerdere test, dan is de stap waarop hij terugkomt al
      // een keer geteld — in de sessie waarin hij hem voor het eerst zag. Nog eens
      // tellen zou vraag 3 zwaarder maken dan vraag 1 en een uitval laten zien die er
      // niet is. Vandaar `stil` hier, en alleen hier.
      applyStep(start, false, hervat);
      sheet.removeAttribute('hidden');
      lockScroll();
      var reveal = function () { sheet.classList.add('is-open'); focusCard(); };
      if (reduceMotion()) { reveal(); return; }
      // Twee frames wachten, anders slaat de browser de transitie over.
      requestAnimationFrame(function () { requestAnimationFrame(reveal); });
    }

    function closeSheet() {
      if (sheet.hasAttribute('hidden')) return;
      animBusy = false;
      // tChoice erbij: sluit iemand de modal in de 150 ms tussen zijn antwoord en de
      // panewissel, dan mag die wissel niet meer plaatsvinden. Anders schuift de
      // bewaarde stap op naar een vraag die hij nooit gezien heeft.
      clearTimeout(tOut); clearTimeout(tIn); clearTimeout(tChoice);
      setAnim('');
      sheet.classList.remove('is-open');
      unlockScroll();
      untrap(openedBy && document.contains(openedBy) ? openedBy : null);
      openedBy = null;
      if (reduceMotion()) { hide(sheet); return; }
      tClose = setTimeout(function () { hide(sheet); }, 240);
    }

    // --- e-mailstap ---

    function showEmailError() {
      if (emailError) { emailError.textContent = cfg.emailError; show(emailError); }
      if (emailInput) { emailInput.setAttribute('aria-invalid', 'true'); emailInput.focus(); }
    }
    function hideEmailError() {
      if (emailError) { emailError.textContent = ''; hide(emailError); }
      if (emailInput) emailInput.setAttribute('aria-invalid', 'false');
    }

    function submitEmail() {
      // Eén keer versturen. De knop blijft tijdens de panewissel nog ~180 ms staan
      // en Enter in het veld doet hetzelfde, dus zonder vlag levert een dubbelklik
      // twee inschrijvingen (en twee bevestigingsmails) op.
      if (!emailInput || submitted) return;
      var value = (emailInput.value || '').trim();
      // Het afgekeurde adres gaat NIET mee: dit meetpunt telt bezoekers die tegen de
      // validatie aanliepen, niet wat ze intypten. Eén keer per paginaweergave — drie
      // keer dezelfde typefout is één bezoeker met een probleem.
      if (!EMAIL_RE.test(value)) { meetEens('frankly_test_email_fout'); showEmailError(); return; }
      hideEmailError();
      state.email = value;
      var key = computeType();
      var handle = handleFor(key) || key;
      // Toestemming wordt gelezen op het moment van verzenden, uit het vakje zelf.
      state.news = newsInput ? !!newsInput.checked : false;
      submitted = true;
      // Nieuwe verzendpoging, dus schone lei: pas de uitkomst hieronder bepaalt of er
      // een mail onderweg is.
      mailFailed = false;
      if (emailSubmit) emailSubmit.disabled = true;
      // De flow gaat direct door naar het resultaat; verzenden loopt op de
      // achtergrond en mag nooit blokkeren, vertragen of falen zichtbaar maken.
      next();
      setTimeout(function () { sendEmailStep(value, key, handle, state.news); }, 0);
    }

    // --- e-mailverzending, fire-and-forget ---
    //
    // Zie de kop van dit bestand voor de tweedeling transactioneel/marketing. Kort:
    // sendTransactional() loopt altijd (voor zover het kanaal het kan) en levert de
    // bevestigingsmail met de claimlink; sendMarketing() loopt alleen met het vinkje
    // aan en is de nieuwsbriefinschrijving. Ze worden nooit door elkaar gehaald.

    function warn(wat) {
      return function (err) { console.warn('[frankly] ' + wat + ' mislukt', err); };
    }

    // Vastleggen dat de mail-producerende POST niet is aangekomen. Eén plek, zodat
    // canEmail() maar naar één vlag hoeft te kijken. persist() erachteraan: de vlag
    // slaat asynchroon om, ná de stapwissel die de staat wegschreef, en zonder deze
    // regel zou een refresh de oude (te optimistische) staat teruglezen.
    function markMailFailed() {
      mailFailed = true;
      persist();
    }

    // Shopify-route: het verborgen {% form 'customer' %} levert action, form_type en utf8.
    //
    // LET OP: deze POST *is* een nieuwsbriefinschrijving. Shopify maakt er een klant
    // van en zet accepts_marketing van die klant op true; `contact[accepts_marketing]`
    // is geen veld dat dit form_type honoreert, dus het weglaten houdt niets tegen.
    // Daarom staat deze functie onder sendMarketing() en wordt ze uitsluitend
    // aangeroepen als het vinkje aan staat. Een niet-marketing-registratie van het
    // huidtype hoort via een ander kanaal te lopen (app-endpoint of
    // customer-metafield), niet hier — vandaar dat de Shopify-route geen
    // transactionele variant heeft.
    // In deze route is dit óók de enige POST die een mail kan veroorzaken (de
    // opt-in-bevestiging), dus elk faalpad hier zet mailFailed: geen inschrijving,
    // geen bevestigingsmail, dus ook geen inbox-scherm.
    function sendShopify(email, handle) {
      var wrapper = document.querySelector('[data-frankly-customer-form]');
      var form = wrapper ? wrapper.querySelector('form') : null;
      if (!form) {
        markMailFailed();
        console.warn('[frankly] geen [data-frankly-customer-form], niets verstuurd');
        return;
      }
      var data;
      try {
        data = new FormData(form);
      } catch (err) {
        markMailFailed();
        warn('nieuwsbriefinschrijving')(err);
        return;
      }
      data.set('contact[email]', email);
      data.set('contact[tags]', cfg.customerTagPrefix + handle + ',' + cfg.funnelTag);
      fetch(form.action, { method: 'POST', body: data, headers: { Accept: 'text/html' } })
        .then(function (res) {
          // Shopify antwoordt met een redirect naar de pagina zelf; fetch volgt die en
          // levert een 2xx. Een 4xx/5xx betekent dus echt dat er niets is ingeschreven.
          if (!res.ok) throw new Error('Shopify antwoordde met ' + res.status);
        })
        .catch(function (err) {
          markMailFailed();
          warn('nieuwsbriefinschrijving')(err);
        });
    }

    // Beide Klaviyo-aanroepen gaan naar hetzelfde publieke client-endpoint: alleen de
    // company id staat in de browser, nooit een private key. Content-type, Accept en
    // de revisie zijn voor /client/events en /client/subscriptions identiek —
    // application/vnd.api+json is wat de API-specificatie voorschrijft.
    // Geeft de promise terug en verwerpt óók bij een HTTP-fout. fetch verwerpt uit
    // zichzelf alleen bij netwerkfouten, dus een 400 — verkeerde company id, ongeldige
    // metricnaam — zou anders volledig onzichtbaar zijn: geen mail, geen melding, geen
    // spoor. Beide client-endpoints antwoorden bij succes met 202 Accepted. De
    // aanroeper handelt de rejectie af; hier staat bewust geen .catch(), anders is de
    // uitkomst daar niet meer te zien en kan canEmail() er niet op reageren.
    function klaviyoPost(path, payload) {
      return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(cfg.klaviyoCompanyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          Accept: 'application/vnd.api+json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo antwoordde met ' + res.status);
        return res;
      });
    }

    // TRANSACTIONEEL — Klaviyo client events. Dit event maakt of werkt het profiel bij
    // ZONDER het op een lijst te zetten, en is de trigger onder de flow die de
    // bevestigingsmail met de claimlink stuurt. Geen marketing, dus geen vinkje nodig.
    function sendKlaviyoEvent(email, key, handle) {
      var payload = {
        data: {
          type: 'event',
          attributes: {
            // Het huidtype hangt aan het EVENT, niet aan het profiel: de flow-mail
            // bouwt de claimlink met {{ event.huidtype }} (§3e stap 7 van
            // FRANKLY-SAMPLING-FUNNEL.md). Zet het hier niet óók als profieleigenschap.
            // Bij wie het vinkje aanzette doet sendKlaviyoSubscription() dat al, en bij
            // wie dat niet deed hoort er zonder toestemming zo min mogelijk op het
            // profiel terecht te komen — dat profiel bestaat alleen om deze ene
            // transactionele mail te kunnen sturen.
            properties: { huidtype: handle, huidtype_key: key },
            metric: { data: { type: 'metric', attributes: { name: cfg.klaviyoMetric } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      };
      // Komt deze POST niet aan, dan komt de bevestigingsmail er ook niet. Dat is de
      // enige plek waar dat te merken valt, dus leggen we het hier vast: het
      // inbox-scherm mag daarna niet meer verschijnen.
      klaviyoPost('events', payload).catch(function (err) {
        markMailFailed();
        warn('transactionele mail')(err);
      });
    }

    // MARKETING — Klaviyo client subscriptions. Zet de toestemming op SUBSCRIBED en
    // hangt het profiel aan de lijst. Alleen met het vinkje aan.
    function sendKlaviyoSubscription(email, key, handle) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Frankly huidtest',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { huidtype: handle, huidtype_key: key, funnel: cfg.funnelTag },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: cfg.klaviyoListId } } }
        }
      };
      // Mislukt deze POST, dan is er geen inschrijving — maar de bevestigingsmail
      // hangt er niet aan (die loopt via het event), dus mailFailed blijft ongemoeid.
      klaviyoPost('subscriptions', payload).catch(warn('nieuwsbriefinschrijving'));
    }

    // De bevestigingsmail met de claimlink. Loopt ALTIJD, ongeacht het vinkje: dit is
    // de afhandeling van een verzoek dat de bezoeker zelf deed. Alleen de
    // Klaviyo-route kan dit — Shopify kent geen manier om te mailen zonder in te
    // schrijven, en bij esp 'none' gaat er per definitie niets weg.
    function sendTransactional(email, key, handle) {
      if (cfg.esp !== 'klaviyo') return;
      // Een half ingerichte Klaviyo-route ziet er van buiten gezond uit: de funnel
      // loopt door, alleen komt er nooit een mail aan. Daarom hier wél een melding.
      if (!cfg.klaviyoCompanyId) {
        console.warn('[frankly] klaviyoCompanyId ontbreekt, geen bevestigingsmail verstuurd');
        return;
      }
      sendKlaviyoEvent(email, key, handle);
    }

    // De nieuwsbrief. Uitsluitend aanroepen met toestemming; deze functie controleert
    // dat bewust niet zelf, zodat er precies één plek is waar het vinkje wordt
    // uitgelezen en die niet stilzwijgend ergens anders wordt overruled.
    function sendMarketing(email, key, handle) {
      if (cfg.esp === 'klaviyo') {
        if (cfg.klaviyoCompanyId && cfg.klaviyoListId) sendKlaviyoSubscription(email, key, handle);
        // Hier heeft iemand actief toestemming gegeven en rekent hij op de korting uit
        // de labeltekst. Gaat dat door een ontbrekende id niet door, dan mag dat niet
        // stilzwijgend gebeuren: de funnel oogt gezond en alleen de lijst blijft leeg.
        else console.warn('[frankly] klaviyoCompanyId of klaviyoListId ontbreekt, nieuwsbriefinschrijving overgeslagen');
        return;
      }
      if (cfg.esp === 'shopify') sendShopify(email, handle);
    }

    // De e-mailstap in één aanroep: eerst de bevestigingsmail, daarna — en alleen met
    // toestemming — de nieuwsbrief. De sample hangt van geen van beide af: de flow
    // loopt hoe dan ook door naar het resultaat.
    //
    // Elk van de twee heeft zijn eigen try/catch. Struikelt de ene, dan gaat de
    // andere gewoon door: een kapotte bevestigingsmail mag geen gegeven toestemming
    // laten verdampen, en een kapotte inschrijving mag de sample niet tegenhouden.
    function sendEmailStep(email, key, handle, news) {
      try {
        sendTransactional(email, key, handle);
      } catch (err) {
        // Struikelt de aanroep zelf, dan is er net zo goed niets verstuurd.
        if (cfg.esp === 'klaviyo') markMailFailed();
        warn('transactionele mail')(err);
      }
      if (!news) return;
      try {
        sendMarketing(email, key, handle);
      } catch (err) {
        // In de Shopify-route is de inschrijving óók de enige mail; in de
        // Klaviyo-route staan ze los en blijft de bevestigingsmail overeind.
        if (cfg.esp === 'shopify') markMailFailed();
        warn('nieuwsbriefinschrijving')(err);
      }
    }

    // Kan er voor deze bezoeker echt een mail uitgaan? Eén bron van waarheid, twee
    // gebruikers: welke pane de claimknop opent, en of het inbox-scherm klopt.
    function canEmail() {
      // Is de POST die de mail veroorzaakt afgeketst, dan helpt geen enkele
      // instelling meer: er is niets verstuurd, dus er komt niets aan.
      if (mailFailed) return false;
      // Klaviyo mailt transactioneel, dus ook zonder vinkje; de list id is alleen
      // voor de nieuwsbrief nodig.
      if (cfg.esp === 'klaviyo') return !!cfg.klaviyoCompanyId;
      // Shopify mailt alleen via de inschrijving, en die vraagt om toestemming. En
      // zelfs mét vinkje komt er alleen post als dubbele opt-in aan staat: die
      // bevestigingsmail ís de enige mail die deze route oplevert. Staat de instelling
      // uit, dan wordt de klant stilzwijgend ingeschreven en gaat er niets uit. Het
      // theme kan die admin-instelling niet uitlezen, dus de winkelier bevestigt hem;
      // zonder die bevestiging beloven we geen mail.
      if (cfg.esp === 'shopify') {
        if (state.news && !cfg.shopifyDoubleOptIn && !warnedOptIn) {
          warnedOptIn = true;
          console.warn('[frankly] shopifyDoubleOptIn staat uit: Shopify stuurt dan geen bevestigingsmail, dus het inbox-scherm wordt overgeslagen');
        }
        return !!state.news && !!cfg.shopifyDoubleOptIn;
      }
      return false;
    }

    // --- claimen vanaf de resultaatpane ---

    // Komt er een mail aan, dan is "kijk in je mail" de volgende stap en wacht de
    // bezoeker op de claimlink. Komt die mail er niet — Shopify zonder vinkje of
    // zonder dubbele opt-in, helemaal geen ESP, of een verzending die is afgeketst —
    // dan zou datzelfde scherm hem laten wachten op post die nooit komt, zonder knop
    // om verder te gaan. In dat geval brengen we hem meteen naar de claimpagina.
    function goToClaim() {
      // Vóór de vertakking, want beide takken zijn dezelfde handeling van de bezoeker:
      // hij heeft op "claim mijn gratis sample" gedrukt. Of hij daarna op het
      // inbox-scherm belandt of meteen op de claimpagina is een keuze van de winkel,
      // geen verschil in wat híj deed.
      meetEens('frankly_test_claim', { huidtype: state.type || computeType() });
      if (canEmail()) { goTo('inbox'); return; }
      var handle = state.handle || handleFor(computeType()) || computeType();
      state.handle = handle;
      // Eerst wegschrijven, dán navigeren: de claimpagina leest ?type=, maar valt op
      // deze staat terug. Draai je de volgorde om, dan is de pagina al geladen
      // voordat het huidtype is bewaard.
      persist();
      var base = cfg.claimUrl || DEFAULTS.claimUrl;
      var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'type=' + encodeURIComponent(handle);
      // Eén beurt voor de gebeurtenislus vóór de navigatie. Dat is geen wachten op het
      // meetpunt — er wordt niets ge-await en de flow blokkeert niet — maar publish()
      // steekt de framegrens over naar de sandbox van de pixel, en die moet daarna nog
      // een eigen taak draaien om er een verzoek van te maken. Start de navigatie in
      // dezelfde slag, dan valt die taak in het venster waarin het document wordt
      // opgeruimd. Zelfde patroon als submitEmail() al gebruikt.
      //
      // Eerlijk over wat dit NIET oplost: is de toestemmingsstand op dit moment nog
      // onbekend, dan staat het meetpunt in het buffertje van meet() en dat sterft met
      // de pagina. Dat gegevens dan verloren gaan is precies goed — zonder toestemming
      // hoort er niets weg te gaan — maar het betekent wel dat "claim geklikt" in de
      // trechter iets lager kan uitvallen dan "resultaat gezien".
      setTimeout(function () { window.location.href = url; }, 0);
    }

    // --- wegklikken naar de winkel ---

    // Het huidtype dat bij dit scherm hoort. Dezelfde uitdrukking als in meetStap() en
    // goToClaim(): renderResult() heeft state.type gezet, computeType() is het vangnet
    // voor het geval de resultaatpane geen enkel blok kon onthullen. Nooit iets anders
    // dan een van de drie vaste sleutels, dus veilig voor een meetpunt.
    function huidtypeNu() { return state.type || computeType(); }

    // De productkaarten en de twee tekstlinks navigeren weg van de funnel. Meten en
    // het daarbij laten is hier niet genoeg: publish() steekt de framegrens over naar
    // de sandbox van de pixel (postMessage) en die moet daarna nog een eigen taak
    // draaien om er een verzoek van te maken. Volgt de browser de link in dezelfde
    // slag, dan valt die taak in het venster waarin het document wordt opgeruimd.
    // Vandaar hetzelfde patroon als goToClaim() en handleClaim(): meten, één beurt
    // voor de gebeurtenislus, dan zelf navigeren. De bezoeker merkt van die ene taak
    // niets en er wordt nergens op gewacht.
    //
    // De navigatie wordt alléén overgenomen als de browser hem anders óók in dít
    // venster zou doen. Een klik met ctrl/cmd/shift/alt, met een andere muisknop, of
    // op een link met target of download opent een nieuw tabblad of venster: deze
    // pagina blijft dan gewoon staan, de pixel heeft alle tijd, en preventDefault()
    // zou de bezoeker precies afpakken wat hij vroeg. Dan meten we alleen.
    //
    // Eerlijk over wat dit NIET oplost, net als bij goToClaim(): is de
    // toestemmingsstand op dit moment nog onbekend, dan staat het meetpunt in het
    // buffertje van meet() en sterft het met de pagina. Dat gegevens dan verloren gaan
    // is precies goed — zonder toestemming hoort er niets weg te gaan.
    function meetEnVolg(event, link, naam, gegevens, sleutel) {
      meetEens(naam, gegevens, sleutel);
      if (event.defaultPrevented) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (typeof event.button === 'number' && event.button !== 0) return;
      if (link.hasAttribute('download')) return;
      var target = link.getAttribute('target');
      if (target && target !== '_self') return;
      // Geen href, geen anchor, of een lege href: niets om over te nemen. De browser
      // doet dan zijn eigen ding en wij hebben in elk geval geteld.
      if (!(link.getAttribute('href') || '').trim()) return;
      var href = link.tagName === 'A' ? link.href : '';
      if (!href) return;
      event.preventDefault();
      setTimeout(function () { window.location.href = href; }, 0);
    }

    // --- events ---

    // Delegatie op document, zodat ook later ingevoegde openknoppen werken.
    document.addEventListener('click', function (event) {
      var opener = closestFrom(event.target, '[data-frankly-open-test]');
      if (!opener) return;
      event.preventDefault();
      openSheet(opener);
    });

    sheet.addEventListener('click', function (event) {
      if (closestFrom(event.target, '[data-frankly-close]')) { event.preventDefault(); closeSheet(); return; }
      if (closestFrom(event.target, '[data-frankly-scrim]')) { closeSheet(); return; }

      // Antwoord op q1..q5: scoort, bevestigt en gaat daarna door.
      var scored = closestFrom(event.target, '[data-frankly-score]');
      if (scored) {
        event.preventDefault();
        if (inputLocked()) return;
        var key = scored.getAttribute('data-frankly-score');
        if (state.scores.hasOwnProperty(key)) state.scores[key] += 1;
        lockInput();
        chooseAndAdvance(scored);
        return;
      }
      // Vraag 5: zet alleen de tijdvoorkeur, scoort niet.
      var timed = closestFrom(event.target, '[data-frankly-time]');
      if (timed) {
        event.preventDefault();
        if (inputLocked()) return;
        state.tijd = timed.getAttribute('data-frankly-time') || '';
        lockInput();
        chooseAndAdvance(timed);
        return;
      }
      if (closestFrom(event.target, '[data-frankly-email-submit]')) { event.preventDefault(); submitEmail(); return; }
      if (closestFrom(event.target, '[data-frankly-claim]')) { event.preventDefault(); goToClaim(); return; }

      // Een betaalde productkaart. Het hele kaartvlak is één link met één bestemming,
      // dus hier valt niets te kiezen: klikken betekent naar dat product. De
      // samplekaart is geen link en komt hier per definitie niet langs.
      //
      // De kaartsoort gaat mee, maar alleen als hij een van de twee afgesproken
      // waarden is. Een meetpunt draagt uitsluitend waarden die dit bestand zelf
      // kiest; wat er in een data-attribuut staat is markup en zou zonder deze filter
      // als vrije tekst in GA4 belanden. Wijkt de markup af, dan telt de klik nog
      // steeds mee — onder 'anders', zodat het aantal blijft kloppen en de afwijking
      // opvalt.
      var kaart = closestFrom(event.target, '[data-frankly-card-link]');
      if (kaart) {
        var soort = kaart.getAttribute('data-frankly-kaart');
        if (soort !== 'extra' && soort !== 'vervolg') soort = 'anders';
        // Per soort ontdubbeld, niet op naam: wie eerst de extra kaart aanklikt,
        // terugkomt en dan de vervolgkaart, deed twee verschillende dingen. Twee keer
        // dezelfde kaart is één bezoeker met één voornemen.
        meetEnVolg(event, kaart, 'frankly_kaart_klik',
          { huidtype: huidtypeNu(), kaart: soort }, 'kaart_klik:' + soort);
        return;
      }
      // De tekstlink onder het resultaat ("bekijk de producten voor jouw huid") en
      // dezelfde toevoeging op het inbox-scherm. Zonder shop_url houdt
      // updateShopLinks() ze hidden en zonder href; ze zijn dan onbereikbaar met muis
      // én toetsenbord, dus komt hier ook nooit een klik langs.
      var shopLink = closestFrom(event.target, '[data-frankly-shop-link]');
      if (shopLink) {
        meetEnVolg(event, shopLink, 'frankly_shoplink_klik', { huidtype: huidtypeNu() });
        return;
      }
      var inboxLink = closestFrom(event.target, '[data-frankly-inbox-link]');
      if (inboxLink) {
        meetEnVolg(event, inboxLink, 'frankly_inboxlink_klik', { huidtype: huidtypeNu() });
      }
    });

    if (emailInput) {
      emailInput.addEventListener('input', hideEmailError);
      emailInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        submitEmail();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (!sheet.hasAttribute('hidden')) closeSheet();
    });
  }

  // ---------- claimpagina ----------

  function initClaim(root) {
    var panes = toArray(root.querySelectorAll('[data-frankly-claim-pane]'));
    var fallbackPane = root.querySelector('[data-frankly-claim-fallback]');
    var claimedPane = root.querySelector('[data-frankly-claim-claimed]');
    var warning = root.querySelector('[data-frankly-cart-warning]');

    // De sectie rendert de "al geclaimd"-pane server-side zichtbaar: dan niets doen —
    // behalve meten. Deze bezoeker wás er, hij werd alleen tegengehouden. Zonder dit
    // meetpunt verdwijnt hij volledig uit de trechter en leest de winkelier hem als
    // iemand die de claimpagina nooit bereikte; bij "één sample per persoon" is dat
    // geen randgeval maar een categorie die je wilt kunnen tellen. Het huidtype is
    // hier per definitie onbekend: de sectie rendert de huidtype-panes in dit geval
    // niet, en ?type= draagt een handle die zonder die panes niet naar een sleutel te
    // vertalen is. Vandaar een eigen bron-waarde in plaats van een half getal.
    if (claimedPane && !claimedPane.hasAttribute('hidden')) {
      meetEens('frankly_claim_geopend', { huidtype: 'onbekend', bron: 'al_geclaimd' });
      return;
    }

    var confirmPending = false, busy = false, labelBefore = null;

    // De waarschuwing is de enige terugkoppeling vóór we een winkelwagen legen, dus
    // moet ze ook aangekondigd worden. role="alert" hoort in de markup; staat het er
    // niet, dan zetten we het hier alsnog. Idem het id, voor aria-describedby.
    if (warning) {
      if (!warning.getAttribute('role')) warning.setAttribute('role', 'alert');
      if (!warning.id) warning.id = 'frankly-cart-warning';
    }

    function showWarning(text) {
      if (!warning) { console.warn('[frankly] geen [data-frankly-cart-warning]:', text); return; }
      // Eerst zichtbaar maken, dan de tekst zetten: een live region die al in de
      // boom staat wordt wél voorgelezen, tekst in een hidden element niet.
      show(warning);
      warning.textContent = text; // nooit innerHTML
    }
    function hideWarning() {
      if (warning) { warning.textContent = ''; hide(warning); }
    }

    // "cart leegmaken" is een sectie-instelling; ontbreekt hij, dan legen we niets.
    function clearEnabled() {
      var value = root.getAttribute('data-frankly-clear-cart');
      return value === 'true' || value === '1';
    }

    function paneFor(value) {
      if (!value) return null;
      for (var i = 0; i < panes.length; i++) {
        if (panes[i].getAttribute('data-frankly-handle') === value ||
            panes[i].getAttribute('data-frankly-claim-pane') === value) return panes[i];
      }
      return null;
    }

    // Pane kiezen: ?type= wint, dan het opgeslagen type, dan de fallback.
    //
    // Welke van de drie het werd is meteen het interessantste getal van deze pagina.
    // 'link' betekent dat het huidtype in de URL stond — en dat is NIET hetzelfde als
    // "hij kwam uit de mail". Ook goToClaim() zet zelf ?type= in de URL zodra er voor
    // deze bezoeker geen mail uitgaat, en dat is precies het geval als de POST naar
    // Klaviyo wordt geblokkeerd (mailFailed). Beide routes zijn hier niet te
    // onderscheiden; lees 'link' dus als "het huidtype stond in de link", uit de mail
    // óf rechtstreeks uit de modal. 'opgeslagen' betekent geen ?type= maar wel een
    // bewaarde test in dezelfde browser, 'onbekend' dat we niets hadden en de fallback
    // tonen — dat laatste is de stille storing waar je op wilt kunnen sturen.
    var wanted = '';
    try { wanted = (new URLSearchParams(window.location.search).get('type') || '').trim(); } catch (err) {}
    var saved = readStore();
    var bron = 'onbekend';
    var chosen = paneFor(wanted);
    if (chosen) bron = 'link';
    if (!chosen && saved) {
      chosen = paneFor(saved.handle) || paneFor(saved.type);
      if (chosen) bron = 'opgeslagen';
    }
    if (!chosen) chosen = fallbackPane || panes[0] || null;

    // Het huidtype hoort bij de pane, niet bij de bezoeker: 'oily' | 'combi' |
    // 'blemish', of 'onbekend' bij de fallback-pane die geen huidtype heeft.
    var huidtype = (chosen && chosen.getAttribute('data-frankly-claim-pane')) || 'onbekend';
    meetEens('frankly_claim_geopend', { huidtype: huidtype, bron: bron });

    if (chosen) {
      panes.forEach(hide);
      hide(fallbackPane);
      hide(claimedPane);
      show(chosen);
    }

    var activeButton = chosen ? chosen.querySelector('[data-frankly-add-sample]') : null;

    // De waarschuwing staat in de markup onderaan .frankly-claim, dus ná het
    // "in je pakketje"-paneel: op mobiel honderden pixels onder de knop, buiten
    // beeld. Bij de knop hangen, waar de tekst hoort. Zelfde klasse, zelfde sectie,
    // dus de styling verandert niet.
    if (warning && activeButton && activeButton.parentNode &&
        !activeButton.parentNode.contains(warning)) {
      try {
        activeButton.parentNode.insertBefore(warning, activeButton.nextSibling);
      } catch (err) { /* blijft staan waar hij stond */ }
    }

    // Verwijst de knop al naar een zichtbare uitleg in de markup — iets anders dan
    // deze waarschuwing zelf — dan die laten staan.
    function hasStaticNote(button) {
      var ids = (button.getAttribute('aria-describedby') || '').split(/\s+/);
      for (var i = 0; i < ids.length; i++) {
        if (!ids[i] || (warning && ids[i] === warning.id)) continue;
        var el = document.getElementById(ids[i]);
        if (el && !el.hasAttribute('hidden')) return true;
      }
      return false;
    }

    // Zonder variant-ID is de knop niet bruikbaar: uitzetten met zichtbare uitleg,
    // maar niet dezelfde tekst twee keer onder elkaar.
    if (activeButton && !(activeButton.getAttribute('data-variant-id') || '').trim()) {
      activeButton.disabled = true;
      if (!hasStaticNote(activeButton)) showWarning(TXT_NO_VARIANT);
      // Ook meten, juist hier. Een uitgeschakelde knop levert geen klik op, dus zonder
      // dit meetpunt zou de winkelier alleen een claimpagina zien waar niemand iets
      // doet — zonder te kunnen zien dat er niets te doen víél. Dezelfde sleutel als
      // in handleClaim(), dus het telt hoe dan ook maar één keer.
      meetEens('frankly_claim_fout', { reden: 'geen_variant' }, 'claim_fout:geen_variant');
    }

    // --- cart ---

    // Eén Error met twee gezichten: de melding die de bezoeker leest, en een korte,
    // vaste reden voor het meetpunt. Die twee zijn met opzet niet hetzelfde. De
    // melding kan servertekst bevatten (Shopify, de validation function) en die hoort
    // niet in een analytics-rapport: vrije tekst is onvoorspelbaar, loopt over de
    // GA4-limiet van 100 tekens en kan van alles bevatten wat wij niet hebben gekozen.
    // De reden is altijd een handvol tekens die dit bestand zelf verzint.
    function franklyFout(melding, reden) {
      var fout = new Error(melding);
      fout.franklyReden = reden;
      return fout;
    }

    function cartGet() {
      return fetch(cartBase() + '.js', { method: 'GET', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        // Onbekende cart als leeg behandelen, zodat we nooit onnodig legen.
        .catch(function () { return { items: [], item_count: 0 }; });
    }

    // fetch verwerpt alleen bij netwerkfouten, dus res.ok zelf controleren: anders
    // gaat de flow na een mislukte leging vrolijk door en belandt de bezoeker met
    // zijn betaalde artikelen én het sample in de checkout.
    function cartClear() {
      return fetch(cartBase() + '/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      }).then(function (res) {
        if (!res.ok) throw franklyFout(TXT_CLEAR_FAILED, 'legen_' + res.status);
      });
    }

    function cartAdd(variantId) {
      var n = Number(variantId);
      var id = isFinite(n) && n > 0 && String(n) === variantId ? n : variantId;
      return fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (res.ok) return data;
          // Fouten uit de validation function komen niet betrouwbaar door de
          // AJAX-API heen, dus altijd een eigen NL-tekst achter de hand.
          // 422 is de winkelwagen-validatie die het sample weigert (bijvoorbeeld
          // omdat er al een sample geclaimd is); die wil je apart kunnen zien van
          // een gewone HTTP-fout.
          throw franklyFout(data.description || data.message || TXT_FAILED,
            res.status === 422 ? 'geweigerd_422' : 'http_' + res.status);
        });
      });
    }

    // Alles in de cart dat niet het sample zelf is.
    function foreignCount(cart, variantId) {
      var items = (cart && cart.items) || [], total = 0;
      for (var i = 0; i < items.length; i++) {
        var id = String(items[i].variant_id != null ? items[i].variant_id : items[i].id);
        if (id !== String(variantId)) total += items[i].quantity || 1;
      }
      return total;
    }

    function setBusy(button, on) {
      busy = on;
      button.disabled = on;
      button.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    // De waarschuwing aan de knop koppelen zonder te overschrijven: de markup zet
    // er zelf al een id in (de uitleg bij een uitgeschakelde knop, en in de sectie
    // ook al deze waarschuwing). Alleen toevoegen, nooit weghalen.
    function describeByWarning(button) {
      if (!warning || !warning.id) return;
      var list = (button.getAttribute('aria-describedby') || '').split(/\s+/);
      var out = [], seen = false, i;
      for (i = 0; i < list.length; i++) {
        if (!list[i]) continue;
        if (list[i] === warning.id) seen = true;
        out.push(list[i]);
      }
      if (seen) return;
      out.push(warning.id);
      button.setAttribute('aria-describedby', out.join(' '));
    }

    // De tweede klik leegt de winkelwagen, dus die klik moet een bewuste
    // bevestiging zijn: de knop zegt zelf wat er gaat gebeuren, en de waarschuwing
    // wordt via role="alert" voorgelezen.
    function enterConfirm(button) {
      if (labelBefore === null) labelBefore = button.textContent;
      button.textContent = TXT_CONFIRM;
      describeByWarning(button);
    }
    function leaveConfirm(button) {
      confirmPending = false;
      if (labelBefore !== null) { button.textContent = labelBefore; labelBefore = null; }
    }

    function handleClaim(button) {
      if (busy) return;
      var variantId = (button.getAttribute('data-variant-id') || '').trim();
      if (!variantId) {
        button.disabled = true;
        showWarning(TXT_NO_VARIANT);
        meetEens('frankly_claim_fout', { reden: 'geen_variant' }, 'claim_fout:geen_variant');
        return;
      }
      setBusy(button, true);
      hideWarning();

      cartGet().then(function (cart) {
        var mustClear = foreignCount(cart, variantId) > 0 && clearEnabled();
        // Eerste klik met een gevulde cart: waarschuwen en wachten op de tweede.
        // De cart wordt nooit stilzwijgend geleegd.
        if (mustClear && !confirmPending) {
          confirmPending = true;
          showWarning(TXT_CLEAR);
          enterConfirm(button);
          setBusy(button, false);
          return null;
        }
        var chain = Promise.resolve();
        if (mustClear) chain = chain.then(cartClear);
        return chain.then(function () { return cartAdd(variantId); });
      }).then(function (result) {
        if (!result) return; // wacht op de tweede klik
        // Het sample zit in de winkelwagen. Meten vóór de navigatie naar de checkout —
        // dit is het laatste moment waarop het nog kan.
        meetEens('frankly_claim_toegevoegd', { huidtype: huidtype });
        clearStore();
        // Vlag achterlaten zodat de modal de test niet hervat na een claim.
        writeStore({ v: 1, step: 'claimed', claimed: true, ts: Date.now() });
        // Navigeren ná één beurt van de gebeurtenislus, om dezelfde reden als in
        // goToClaim(): publish() moet nog door de sandbox van de pixel heen. De knop
        // staat op busy, dus de bezoeker merkt van die ene taak niets, en de flow
        // wacht nergens op. Staat het meetpunt nog in het buffertje omdat de
        // toestemmingsstand onbekend is, dan gaat het alsnog verloren — dat is de
        // bedoelde uitkomst, geen storing.
        setTimeout(function () { window.location.href = shopRoot() + 'checkout'; }, 0);
      }).catch(function (err) {
        setBusy(button, false);
        // Mislukt er iets, dan begint de bevestiging opnieuw: is de cart nog
        // gevuld, dan volgt eerst weer de waarschuwing. Nooit stilzwijgend legen.
        leaveConfirm(button);
        showWarning((err && err.message) || TXT_FAILED);
        // Alleen de vaste reden, nooit err.message: daar kan servertekst in zitten.
        // Geen reden op de fout betekent dat fetch zelf verwierp — netwerk, blocker,
        // afgebroken verbinding.
        var reden = (err && typeof err.franklyReden === 'string' && err.franklyReden) || 'netwerk';
        meetEens('frankly_claim_fout', { reden: reden }, 'claim_fout:' + reden);
      });
    }

    root.addEventListener('click', function (event) {
      var button = closestFrom(event.target, '[data-frankly-add-sample]');
      if (!button) return;
      event.preventDefault();
      handleClaim(button);
    });
  }

  // ---------- start; beide onderdelen zijn optioneel ----------

  function boot() {
    var sheet = document.querySelector('[data-frankly-sheet]');
    if (sheet) initTest(sheet);
    var claimRoot = document.querySelector('[data-frankly-claim-root]');
    if (claimRoot) initClaim(claimRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
